import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"lemon-slice"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 10.4882C22 7.55726 19.935 3.90646 18 2L10.5 9.5L3 17C4.90646 18.9349 8.55725 21 11.4882 21C14.391 21 17.0189 19.8234 18.9212 17.9212C20.8234 16.0189 22 13.391 22 10.4882Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10.7632 9.76316L18.65 17.65M11.0391 9.54632L21.75 10.4668M10.5618 10.2188L11.4667 20.75M22 10.4882C22 7.55726 19.935 3.90646 18 2L3 17C4.90646 18.9349 8.55725 21 11.4882 21C17.2937 21 22 16.2937 22 10.4882Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LemonSlice = Vue.extend<IconProps>({
  name: 'LemonSliceIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'lemon-slice',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LemonSlice;
